import {Decoder, field, object} from 'json-bouncer'
import {Product, productDecoder} from './Product'
import {Position, positionDecoder} from './Position'

export interface PositionWithProduct {
    position: Position
    product: Product
}

export function positionWithProductDecoder(): Decoder<PositionWithProduct> {
    return object({
        position: field('position', positionDecoder()),
        product: field('product', productDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PositionWithProduct.ts